require('./account.component.scss');

/*@ngInject*/
class AccountController {
  constructor(
    $scope,
    $element,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$scope.fact = this.fact;
  }

  showAccounts() {
    const rect = this.$element.context.getBoundingClientRect();
    const menu = this.$element.find('div > div');
    const chatViewer = $(document).find('sc-chat-viewer');
    let left = rect.left;
    if (chatViewer.length) {
      const tWidth = this.$element.find('table').width();
      const pRect = chatViewer[0].getBoundingClientRect();
      const space = pRect.right - rect.left - tWidth;
      left = space > 0 ? rect.left : rect.left + space;
    }
    menu.css('left', left);
    menu.css('top', rect.top + 10);
    menu.css('visibility', 'visible');
  }

  hideAccounts() {
    this.$element.find('div > div').css('visibility', 'hidden');
  }

  get accountEmails() {
    const accountsEmails = {};
    for (const key in this.fact.accounts) {
      for (const acc of this.fact.accounts[key]
          .filter(acc => acc.user_name == this.userName)) {
        accountsEmails[acc.mail] = acc;
      }
    }
    return Object.values(accountsEmails).sort((a, b) => a.mail > b.mail ? -1 : 1);
  }

  get accounts() {
    return this.fact.accounts ? this.fact.accounts[this.accountKey] || [] : [];
  }

  get alias() {
    // return this.fullName ? this.fullName : (this.userName ? this.userName: this.account);
    return this.fullName || this.userName || this.accountKey;
  }

  get id() {
    return this.accounts.length ? this.accounts[0].id : 0;
  }

  get userName() {
    return this.accounts.length ? this.accounts[0].user_name : '';
  }

  get fullName() {
    return this.accounts.length ? this.accounts[0].full_name : '';
  }
}

export const AccountComponent = {
  template: require('./account.component.html'),
  controller: AccountController,
  bindings: {
    accountKey: '<',
    fact: '<',
    dkey: '<',
  },
  // resolve: '^facts'
};



// WEBPACK FOOTER //
// ./src/facts/account/account.component.js